// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"draft"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12 17C13.8638 17 15.4299 15.7252 15.874 14H22V21H2V14H8.12602C8.57006 15.7252 10.1362 17 12 17Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M12 17C13.8638 17 15.4299 15.7252 15.874 14L20 14V3H4V14L8.12602 14C8.57006 15.7252 10.1362 17 12 17Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4 14V3H20V14M15.874 14C15.4299 15.7252 13.8638 17 12 17C10.1362 17 8.57006 15.7252 8.12602 14H2V21H22V14H15.874Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M8 7H16M8 11H12","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-draft')
export default class DraftIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'draft',
    }
  }
}
